/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';

import { AddressFragmentDoc } from '../../../graphql/fragments/CustomerData.generated';
import { ValidationErrorResponseFragmentDoc } from '../../ReorderingScreen/GraphQL/Reorder.generated';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type DeliveryPreferenceType = 'CURBSIDE' | 'DOOR' | 'LEAVE_AT_DOOR';

export type EditAddressV2Input = {
  readonly city: string;
  /** 2 letter country code */
  readonly country: string;
  readonly deliveryPreference: DeliveryPreferenceType;
  readonly id: string | number;
  readonly latitude: number;
  readonly longitude: number;
  readonly name?: string | null | undefined;
  readonly notes?: string | null | undefined;
  readonly secondaryStreet?: string | null | undefined;
  /** 2 letter state code */
  readonly state: string;
  readonly street: string;
  readonly zipCode: string;
};

export type UpdateBagDeliveryPreferencesMutationVariables = Exact<{
  input: Types.EditAddressV2Input;
}>;

export type UpdateBagDeliveryPreferencesMutation = {
  readonly updateAddressV2:
    | { readonly __typename: 'InvalidAddress'; readonly message: string; readonly status: number }
    | {
        readonly __typename: 'UpdateAddressSuccess';
        readonly address: {
          readonly __typename: 'Address';
          readonly id: string;
          readonly street: string;
          readonly secondaryStreet: string | null;
          readonly name: string | null;
          readonly city: string;
          readonly state: string;
          readonly zipCode: string;
          readonly country: string;
          readonly deliveryPreference: Types.DeliveryPreferenceType;
          readonly googlePlaceId: string;
          readonly latitude: number;
          readonly longitude: number;
          readonly notes: string | null;
        };
      }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{ readonly field: string; readonly message: string }>;
      };
};

export const UpdateBagDeliveryPreferencesDocument = gql`
  mutation updateBagDeliveryPreferences($input: EditAddressV2Input!) {
    updateAddressV2(input: $input) {
      __typename
      ... on UpdateAddressSuccess {
        address {
          id
          ...address
        }
      }
      ... on ValidationError {
        ...ValidationErrorResponse
      }
      ... on InvalidAddress {
        message
        status
      }
    }
  }
  ${AddressFragmentDoc}
  ${ValidationErrorResponseFragmentDoc}
`;

export function useUpdateBagDeliveryPreferencesMutation() {
  return Urql.useMutation<
    UpdateBagDeliveryPreferencesMutation,
    UpdateBagDeliveryPreferencesMutationVariables
  >(UpdateBagDeliveryPreferencesDocument);
}
